import { DisclosureList } from 'components/misc/DisclosureList';
import { getLinks } from 'pages/matters/util.tsx';
import { FormattedMessage } from 'react-intl';
import { MatterExperienceRecordDto } from 'types/experience-records.ts';
import { MatterEmployeeRoleType } from 'types/matters.ts';

/** Employees shown before the list collapses behind a "+n more" toggle. */
const COLLAPSED_COUNT = 3;

interface Props {
    record: MatterExperienceRecordDto;
}

/** The matter's assigned employees, past the third one behind an expand toggle. Payment-notification
 *  receivers are excluded — they are a billing contact, not someone assigned to the work. */
export function AssignedEmployeesCell({ record }: Props) {
    const employees =
        record.matter.employees
            ?.filter((e) => e.matterEmployeeRoleTypeCode !== MatterEmployeeRoleType.PAYMENT_NOTIFICATION_RECEIVER)
            .map((e) => e.employee) || [];

    return (
        <DisclosureList
            items={employees}
            maxVisibleItems={COLLAPSED_COUNT}
            className="flex-col"
            renderVisible={(visible) => getLinks('employee', visible, { separator: null })}
            moreLabel={(count) => <FormattedMessage id="plus-n-more" values={{ count }} />}
            lessLabel={<FormattedMessage id="minus-show-less" />}
        />
    );
}
